import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import {Icon} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { sortBy } from 'lodash';
import moment from '../../util/moment';
import DVRCardDetail from './DVRCardDetail';
import DVRCardIcon from '../../images/dvr-health-icon-green.svg';
import {closeSnapshotsCarousel} from '../../DVRSnapshots/DVRSnapshotsActions';
import {isMobile} from '../../app/configuration/util';
import FormatedDate from '../component/FormatedDate';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import camerasPerMachineType, { CAMERA_VIEWS } from '../../app/configuration/cameras';


// TODO: add default props and props type
class DVRCard extends React.Component {
  state = {
    detailedView: false
  }

  onClose = () => {
    this.props.closeSnapshotsCarousel();
    this.setState({detailedView: false});
  }

  handleOpen = () => {
    this.setState({detailedView: true});
  };

  reorderSnapshots = (snapshots, machineType) => {
    const snaps = [];
    const CAMERA_CHANNELS = CAMERA_VIEWS.get(machineType);
    const CAMERA_CHANNELS_SORTED = sortBy(CAMERA_CHANNELS, c => c.formOrder);
    CAMERA_CHANNELS_SORTED && Object.keys(CAMERA_CHANNELS_SORTED).forEach((key) => {
      const snapUrl = snapshots?.find(snap => snap.id === CAMERA_CHANNELS_SORTED[key].channelIndex)?.url;
      snaps.push({
          name: CAMERA_CHANNELS_SORTED[key].detailskey,
          url: snapUrl,
          index: CAMERA_CHANNELS_SORTED[key].channelIndex,
      });
    });
    return snaps;
  }

  render() {
    const {id, health, healthy, vehicle, serialNo, substatus, snapshot, lastSnapshotDate, machineType, type} = this.props;
    const lastOnline = health.lastOnlineDate;
    const lastIgnition = health.lastIgnitionDate;

    const fakeSnapshots = [
      { name: 'forwardFacing', image: null },
      { name: 'rear', image: null },
      { name: 'driver', image: null },
      { name: 'passenger', image: null }
    ];

    let healthStatus = '';
    if (!healthy) {
      if (substatus.uncategorized || substatus.hasdvrnotrecording) {
        healthStatus = 'dvrcard__unhealthy';
      } else if (substatus.hasnoimage) {
        healthStatus = 'dvrcard__cameraissue';
      } else if (substatus.dimensionunmatched || substatus.dimensionunvailable) {
        healthStatus = 'dvrcard__warning';
      }
    }

    const HealthIcon = () => {
      if (!healthy) {
        if (substatus.uncategorized) {
          return (<Icon className="dvrcard__icon dvrcard__unhealthyicon">warning</Icon>);
        } else if (substatus.hasnoimage || substatus.hasdvrnotrecording) {
          return (<Icon className="dvrcard__icon dvrcard__camissueicon">videocam_off</Icon>);
        } else if (substatus.dimensionunmatched || substatus.dimensionunvailable) {
          return (<Icon className="dvrcard__icon dvrcard__warningicon">warning</Icon>);
        }
      }
      return (<img src={DVRCardIcon} className="dvrcard__icon dvrcard__icon-info dvrcard__healthyicon"/>)
    };

    const reorderedSnapshots = snapshot ? this.reorderSnapshots(snapshot, machineType) : this.reorderSnapshots(fakeSnapshots, machineType);

    return (
      <Grid item xs={12} sm={6} md={3} className="dvrcard-mediaquery">
        <Card id={id} onClick={this.handleOpen}>
          <CardContent className={`dvrcard ${healthStatus}`}>
            <Grid container>
              <Grid item xs={7} sm={12} md={7} className="dvrcard__item dvrcard-flex">
                <HealthIcon />
                <span>
                  <label className="dvrcard__label">{I18n.t('page.dvrHealth.dvr.vehicle')}</label>
                  <div className="dvrcard__info">{vehicle}</div>
                </span>
              </Grid>
              <Grid item xs={5} sm={12} md={5} className="dvrcard__item">
                <label className="dvrcard__label">{I18n.t('page.dvrHealth.dvr.serial')}</label>
                <div className="dvrcard__info">{serialNo}</div>
              </Grid>
              <Grid item xs={7} sm={12} md={7} className="dvrcard__item">
                <label className="dvrcard__label">{I18n.t('page.dvrHealth.dvr.lastOnline')}</label>
                <div className="dvrcard__info">{moment(lastOnline).format(I18n.t('configuration.fullDateTimeFormat'))}</div>
              </Grid>
              <Grid item xs={5} sm={12} md={5} className="dvrcard__item">
                <label className="dvrcard__label">{type === 'snapshot' ? I18n.t('page.dvrHealth.dvr.lastSnapshotDate') : I18n.t('page.dvrHealth.dvr.lastIgnition')}</label>
                <div className="dvrcard__info"><FormatedDate date={type === 'snapshot' ? lastSnapshotDate : lastIgnition} /></div>
              </Grid>
            </Grid>
            {
              type === 'snapshot' ?
                <ImageList cols={2} gap={0}>
                  {
                    reorderedSnapshots.map(s =>
                    (<ImageListItem key={`${vehicle}_${s.index}_${s.url}`}>
                      <img id={`${vehicle}_${s.name}snapshot`} src={s.url} className="dvrcard__snapshotBackground dvrcard__snapshotAspectRatio" />
                    </ImageListItem>))
                  }
                </ImageList>
                : null
            }
          </CardContent>
        </Card>

        <DVRCardDetail
          {...this.props}
          id={`${id}Detail`}
          key={serialNo}
          onClose={this.onClose}
          open={this.state.detailedView}
        />
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {...state, isMobile: isMobile(state)};
};

export default connect(mapStateToProps, {closeSnapshotsCarousel})(DVRCard);
